import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: "100%",
        "& > .MuiAccordion-root": {
            display: "flex",
        },
        backgroundColor: "#1F56A3",
        overflowX: "hidden",
        "& .MuiCollapse-wrapperInner": {
            width: "100% !important",
        },
    },
    menu: {
        height: "100%",
        boxSizing: "border-box",
        transition: "width 300ms !important",
        paddingLeft: 0,
        paddingRight: 0,
        transform: "unset !important",
        visibility: "unset",
        background: "#2C4F83",
        justifyContent: "space-between",
    },
    container: {
        display: "flex",
        flex: "1 1",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.spacing(2),
        pt: 0,
    },
    largeButton: {
        minWidth: "0px",
        width: 150,
        height: 34,
        // color: "context.white",
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
        justifyContent: "flex-start",
        // backgroundColor: "primary.dark", ACTIVATE
    },
    smallButton: {
        minWidth: "0px",
        width: 34,
        height: 34,
        // color: "context.white",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        justifyContent: "flex-start",
        // backgroundColor: "primary.dark", ACTIVATE
    },
    drawerSx: {
        height: "100%",
        flexShrink: 0,
        background: "#2C4F83",
        whiteSpace: "nowrap",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
    },
    menuMobile: {
        background: "#2C4F83",
        justifyContent: "space-between",
    },
}); });
